@if (modalService.currentModal(); as currentModal) {
  @switch (currentModal.type) {
    @case (ModalType.ARTIST) {
      <art-artist-modal [data]="currentModal.data"></art-artist-modal>
    }
    @case (ModalType.ARTWORK) {
      <art-artwork-detail-modal [data]="currentModal.data"></art-artwork-detail-modal>
    }
  }
}
